import React from 'react';
import './homePageBlock.css';

const HomePageBlock = () => (
  <div className='homepage-block'>
    <h1 className='homepage-title'>Welcome To GoT Database</h1>
  </div>
)

export default HomePageBlock